<template>
  <div class="textarea-field">
    <i class="icon icon--list"></i>
    <div class="textarea-field__float-label">
      <textarea
        :value="value"
        @input="$emit('input', $event.target.value)"
        class="textarea-field__textarea"
        :placeholder="placeholder"
        :name="name"
        :id="name"
        cols="50"
        rows="5"
      ></textarea>
      <label class="textarea-field__label" :for="name">{{ placeholder }}</label>
      <span v-if="hasError" class="error">{{ hasError }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Textarea",
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    hasError: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss">
.textarea-field {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 0.5em 0;
  &__float-label {
    position: relative;
    width: 100%;
  }
  i {
    width: 1.5em;
    height: 1.5em;
    margin-right: 1em;
    transform: translateY(15px);
  }
  &__textarea {
    font-family: $font;
    width: 100%;
    margin: 1em 0 5px;
    border: 0;
    border-radius: 0;
    outline: 0;
    box-shadow: none;
    font-size: 1.6rem;
    color: black;
    background-color: transparent;
    border-bottom: 1px solid $whitegray;
    overflow: auto;
    resize: none;
    &::placeholder {
      opacity: 0;
      transition: $transition;
    }
    &:placeholder-shown:not(:focus)::placeholder {
      opacity: 0;
    }
    &:placeholder-shown:not(:focus) + label {
      font-size: 1.4rem;
      transform: translateY(15px);
      color: $gray;
    }
    &:focus {
      border-bottom: 1px solid $lightred;
    }
  }
  &__label {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateY(0);
    font-size: 1.2rem;
    pointer-events: none;
    color: $lightred;
    transition: $transition;
  }
}
</style>
